export enum IconPosition {
  Begin = 'begin',
  End = 'end',
}
